import AsyncCallHandler from '../common/AsyncCallHandler'
import ACTION_TYPES from './actionTypes'
import NEXUS_CONST from '../common/constants'

export const fetchKaizenCategories = (dispatch, site) => {
    AsyncCallHandler(NEXUS_CONST.FETCH_KAIZEN_CATEGORIES + site, NEXUS_CONST.GET)
        .then(res => {
            dispatch({ type: ACTION_TYPES.FETCH_KAIZEN_CATEGORIES, payload: res.data });
        });
}

export const fetchKaizenArea = (dispatch, site) => {
    AsyncCallHandler(NEXUS_CONST.FETCH_KAIZEN_AREA + site, NEXUS_CONST.GET)
        .then(res => {
            dispatch({ type: ACTION_TYPES.FETCH_KAIZEN_AREA, payload: res.data });
        });
}

export const fetchKaizenCell = (dispatch, site, area) => {
    AsyncCallHandler(NEXUS_CONST.FETCH_KAIZEN_CELL + "area=" + area + "&SiteID=" + site, NEXUS_CONST.GET)
        .then(res => {
            dispatch({ type: ACTION_TYPES.FETCH_KAIZEN_CELL, payload: res.data });
        });
}

export const fetchKaizenUserData = (dispatch) => {
    AsyncCallHandler(NEXUS_CONST.FETCH_KAIZEN_USER_DATA, NEXUS_CONST.GET)
        .then(res => {
            dispatch({ type: ACTION_TYPES.FETCH_KAIZEN_USER_DATA, payload: res.data });
        });
}

export const fetchKaizenAllUsers = (dispatch) => {
    AsyncCallHandler(NEXUS_CONST.FETCH_KAIZEN_ALL_USERS, NEXUS_CONST.GET)
        .then(res => {
            dispatch({ type: ACTION_TYPES.FETCH_KAIZEN_ALL_USERS, payload: res.data.employee });
        });
}

export const fetchManagerDetails = (dispatch, email) => {
    AsyncCallHandler(NEXUS_CONST.FETCH_MANAGER_DETAILS + email, NEXUS_CONST.GET)
        .then(res => {
            dispatch({ type: ACTION_TYPES.FETCH_MANAGER_DETAILS, payload: res.data });
        });
}

export const updateKaizenStatus = (dispatch, status) => {
    dispatch({ type: ACTION_TYPES.UPDATE_KAIZEN_STATUS, payload: status })
}

export const addKaizenRaiseCI = (dispatch, data) => {
    AsyncCallHandler(NEXUS_CONST.ADD_KAIZEN_RAISE_CI, NEXUS_CONST.POST, data)
        .then(res => {
            dispatch({ type: ACTION_TYPES.UPDATE_KAIZEN_STATUS, payload: { type: "success", message: "CI Raised Successfully....!" } });
        });
}

export const getKaizenCIList = (dispatch, site, action) => {
    AsyncCallHandler(NEXUS_CONST.GET_KAIZEN_CI_LIST + "tierId=" + site + "&action=" + action, NEXUS_CONST.GET)
        .then(res => {
            dispatch({ type: ACTION_TYPES.GET_KAIZEN_CI_LIST, payload: res.data });
        });
}

export const manageKaizenRaiseCI = (dispatch, data) => {
    AsyncCallHandler(NEXUS_CONST.MANAGE_KAIZEN_RAISE_CI, NEXUS_CONST.POST, data)
        .then(res => {
            dispatch({ type: ACTION_TYPES.UPDATE_KAIZEN_STATUS, payload: { type: "success", message: "CI Updated Successfully....!" } });
        });
}

export const updateKaizenRaiseCI = (dispatch, data) => {
    AsyncCallHandler(NEXUS_CONST.UPDATE_KAIZEN_RAISE_CI, NEXUS_CONST.POST, data)
        .then(res => {
            dispatch({ type: ACTION_TYPES.GET_KAIZEN_CI_LIST, payload: res.data });
        });
}

export const fetchKaizenSiteFocalInfo = (dispatch, site) => {
    AsyncCallHandler(NEXUS_CONST.FETCH_KAIZEN_SITE_FOCAL_INFO + site, NEXUS_CONST.GET)
        .then(res => {
            dispatch({ type: ACTION_TYPES.FETCH_KAIZEN_SITE_FOCAL_INFO, payload: res.data });
        });
}

export const fetchKaizenDataById = (dispatch, data) => {
    AsyncCallHandler(NEXUS_CONST.FETCH_KAIZEN_DATA_BY_ID, NEXUS_CONST.POST, data)
        .then(res => {
            dispatch({ type: ACTION_TYPES.FETCH_KAIZEN_DATA_BY_ID, payload: res.data });
        });
}

export const fetchNominationKaizenData = (dispatch, siteId) => {
    AsyncCallHandler(NEXUS_CONST.FETCH_NOMINATION_KAIZEN_DATA + siteId, NEXUS_CONST.GET)
        .then(res => {
            dispatch({ type: ACTION_TYPES.FETCH_NOMINATION_KAIZEN_DATA, payload: res.data });
        });
}

export const fetchAdminNominatedKaizenData = (dispatch, siteId) => {
    AsyncCallHandler(NEXUS_CONST.FETCH_ADMIN_NOMINATED_KAIZEN_DATA + siteId, NEXUS_CONST.GET)
        .then(res => {
            dispatch({ type: ACTION_TYPES.FETCH_ADMIN_NOMINATED_KAIZEN_DATA, payload: res.data });
        });
}
export const manageAdminNominatedKaizenData = (dispatch, props) => {
    AsyncCallHandler(NEXUS_CONST.MANAGE_ADMIN_NOMINATED_KAIZEN_DATA, NEXUS_CONST.POST, props)
        .then(res => {
            fetchAdminNominatedKaizenData(dispatch, props.tierId)
        });
}

export const fetchKaizenAdminData = (dispatch, siteId) => {
    AsyncCallHandler(NEXUS_CONST.FETCH_KAIZEN_ADMIN_LIST + siteId, NEXUS_CONST.GET)
        .then(res => {
            dispatch({ type: ACTION_TYPES.FETCH_KAIZEN_ADMIN_DELETE_LIST, payload: res.data });
        });
}

export const deleteKaizenAdminData = (dispatch, data) => {
    AsyncCallHandler(NEXUS_CONST.DELETE_KAIZEN_ADMIN_BY_ID + data.siteId + '&kaizenId=' + data.kaizenId, NEXUS_CONST.POST)
        .then(res => {
            fetchKaizenAdminData(dispatch, data.siteId)
        });
}